const talkJSConfig = {
  appId: "tcfO7HPc"
}

export default talkJSConfig
